export function isValidSortCartBy(
  value: string | null | undefined
): value is 'alphabetical' | 'orderGuide' {
  return value === 'alphabetical' || value === 'orderGuide';
}
